<div class="layout-row layout-align-start-center" [ngbTooltip]="tooltipTmpl" openDelay="300" triggers="hover">

  <app-bringoz-state-link [state]="'customer.active-deliveries'"
                          [permission]="'customer.get'"
                          [params]="{id: customer.customerId}"
                          [text]="customer.name || customer.businessName">
  </app-bringoz-state-link>

</div>

<ng-template #tooltipTmpl>
  <div class="layout-column">
    <span appBringozPpi>{{customer.name || customer.businessName}}</span>
    <span *ngIf="address">{{address | bringozAddress}}</span>
    <span appBringozPpi *ngIf="phone">{{phone | bringozPhone}}</span>
    <span appBringozPpi *ngIf="additionalPhone">{{additionalPhone | bringozPhone}}</span>
  </div>
</ng-template>





